module.exports = __webpack_public_path__ + "static/media/avatar.7b4e5de8.svg";